export default __webpack_public_path__ + "static/bienfaits-sante-32818fd4ccbb809fd3e25c879b6f5fa0.png";